
import { useState } from 'react';

export default function FAQPreviewSection() {
  const [openFAQ, setOpenFAQ] = useState<number | null>(0);

  const faqs = [
    {
      question: 'What is the Skills Development Levy and who needs to pay it?',
      answer: 'The Skills Development Levy (SDL) is a mandatory 1% levy on the annual payroll of companies with an annual payroll exceeding R500,000. This levy funds skills development initiatives and is administered by SARS. Companies can recover up to 69.5% of their SDL through mandatory and discretionary grants.'
    },
    {
      question: 'When are the key SETA compliance deadlines?',
      answer: 'The main deadline is April 30th for both Workplace Skills Plan (WSP) and Annual Training Report (ATR) submission, plus ongoing deadlines for discretionary grant applications throughout the year. Missing these deadlines can result in penalties and loss of grant funding.'
    },
    {
      question: 'How can training improve our B-BBEE scorecard?',
      answer: 'Skills development contributes significantly to your B-BBEE scorecard under the Skills Development element. Training black employees, people with disabilities, and implementing learnerships can earn substantial points. We help design training programmes that maximise your B-BBEE compliance while developing your workforce.'
    },
    {
      question: 'What is the difference between mandatory and discretionary grants?',
      answer: 'Mandatory grants (20% of SDL) are automatically available for compliant WSP and ATR submissions. Discretionary grants (49.5% of SDL) require separate applications and are awarded competitively based on strategic priorities. We assist with both types of applications to maximise your funding recovery.'
    }
  ];

  return (
    <section className="section-wrap bg-gray-50">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="section-heading">
            Frequently Asked Questions
          </h2>
          <p className="text-xl text-gray-600">
            Quick answers to common training and compliance questions
          </p>
        </div>

        <div className="space-y-4 mb-12">
          {faqs.map((faq, index) => (
            <div key={index} className="bg-white rounded-xl border border-gray-200 overflow-hidden">
              <button
                className="w-full px-6 py-4 text-left flex items-center justify-between hover:bg-gray-50 transition-colors"
                onClick={() => setOpenFAQ(openFAQ === index ? null : index)}
              >
                <h3 className="font-semibold text-gray-900 pr-4">{faq.question}</h3>
                <div className={`w-6 h-6 text-[#2D7F3E] transition-transform ${openFAQ === index ? 'rotate-180' : ''}`}>
                  <i className="ri-arrow-down-s-line text-xl"></i>
                </div>
              </button>
              
              {openFAQ === index && (
                <div className="px-6 pb-4">
                  <div className="border-t border-gray-100 pt-4">
                    <p className="text-gray-600 leading-relaxed">{faq.answer}</p>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="text-center">
          <div className="card p-8">
            <div className="w-16 h-16 bg-[#2D7F3E] text-white rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-question-answer-line text-2xl"></i>
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-2">
              Have More Questions?
            </h3>
            <p className="text-gray-600 mb-6">
              Browse our comprehensive FAQ section or speak directly with our experts
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button className="btn btn-primary">
                View All FAQs
              </button>
              <button className="btn btn-secondary">
                Ask an Expert
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
